import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService } from '../_services';
import { Member } from '../_models';
import { ApiService } from '../_services/api.service';
import { Associate } from '../_models/associate.model';
import { AlertPopupService, MessageSeverity } from '../shared/services/alert.service';
import { ConfigService } from '../_services/config.service';
import { WhitelabelService } from '../_services/whitelabel.service';
import { AppComponent } from '../app.component';

@Component(
    {
        templateUrl: 'update-first-time.component.html',
        selector: 'update-first-time',
        styleUrls: ['update-first-time.component.scss']
    }
)
export class UpdateFirstTimeComponent implements OnInit {
    @Input() member: Member
    @Output() memberChange = new EventEmitter();
    verificationId: string;
    isVerified= false;
    gurardians: Associate[] =[];
    over18: boolean= false;
    loading = false;
    dependents: Associate[]=[];
    associatesFormGroup: FormGroup;

    statesList = [
        {
            "name": "Alabama",
            "abbreviation": "AL"
        },
        {
            "name": "Alaska",
            "abbreviation": "AK"
        },
        {
            "name": "American Samoa",
            "abbreviation": "AS"
        },
        {
            "name": "Arizona",
            "abbreviation": "AZ"
        },
        {
            "name": "Arkansas",
            "abbreviation": "AR"
        },
        {
            "name": "California",
            "abbreviation": "CA"
        },
        {
            "name": "Colorado",
            "abbreviation": "CO"
        },
        {
            "name": "Connecticut",
            "abbreviation": "CT"
        },
        {
            "name": "Delaware",
            "abbreviation": "DE"
        },
        {
            "name": "District Of Columbia",
            "abbreviation": "DC"
        },
        {
            "name": "Federated States Of Micronesia",
            "abbreviation": "FM"
        },
        {
            "name": "Florida",
            "abbreviation": "FL"
        },
        {
            "name": "Georgia",
            "abbreviation": "GA"
        },
        {
            "name": "Guam",
            "abbreviation": "GU"
        },
        {
            "name": "Hawaii",
            "abbreviation": "HI"
        },
        {
            "name": "Idaho",
            "abbreviation": "ID"
        },
        {
            "name": "Illinois",
            "abbreviation": "IL"
        },
        {
            "name": "Indiana",
            "abbreviation": "IN"
        },
        {
            "name": "Iowa",
            "abbreviation": "IA"
        },
        {
            "name": "Kansas",
            "abbreviation": "KS"
        },
        {
            "name": "Kentucky",
            "abbreviation": "KY"
        },
        {
            "name": "Louisiana",
            "abbreviation": "LA"
        },
        {
            "name": "Maine",
            "abbreviation": "ME"
        },
        {
            "name": "Marshall Islands",
            "abbreviation": "MH"
        },
        {
            "name": "Maryland",
            "abbreviation": "MD"
        },
        {
            "name": "Massachusetts",
            "abbreviation": "MA"
        },
        {
            "name": "Michigan",
            "abbreviation": "MI"
        },
        {
            "name": "Minnesota",
            "abbreviation": "MN"
        },
        {
            "name": "Mississippi",
            "abbreviation": "MS"
        },
        {
            "name": "Missouri",
            "abbreviation": "MO"
        },
        {
            "name": "Montana",
            "abbreviation": "MT"
        },
        {
            "name": "Nebraska",
            "abbreviation": "NE"
        },
        {
            "name": "Nevada",
            "abbreviation": "NV"
        },
        {
            "name": "New Hampshire",
            "abbreviation": "NH"
        },
        {
            "name": "New Jersey",
            "abbreviation": "NJ"
        },
        {
            "name": "New Mexico",
            "abbreviation": "NM"
        },
        {
            "name": "New York",
            "abbreviation": "NY"
        },
        {
            "name": "North Carolina",
            "abbreviation": "NC"
        },
        {
            "name": "North Dakota",
            "abbreviation": "ND"
        },
        {
            "name": "Northern Mariana Islands",
            "abbreviation": "MP"
        },
        {
            "name": "Ohio",
            "abbreviation": "OH"
        },
        {
            "name": "Oklahoma",
            "abbreviation": "OK"
        },
        {
            "name": "Oregon",
            "abbreviation": "OR"
        },
        {
            "name": "Palau",
            "abbreviation": "PW"
        },
        {
            "name": "Pennsylvania",
            "abbreviation": "PA"
        },
        {
            "name": "Puerto Rico",
            "abbreviation": "PR"
        },
        {
            "name": "Rhode Island",
            "abbreviation": "RI"
        },
        {
            "name": "South Carolina",
            "abbreviation": "SC"
        },
        {
            "name": "South Dakota",
            "abbreviation": "SD"
        },
        {
            "name": "Tennessee",
            "abbreviation": "TN"
        },
        {
            "name": "Texas",
            "abbreviation": "TX"
        },
        {
            "name": "Utah",
            "abbreviation": "UT"
        },
        {
            "name": "Vermont",
            "abbreviation": "VT"
        },
        {
            "name": "Virgin Islands",
            "abbreviation": "VI"
        },
        {
            "name": "Virginia",
            "abbreviation": "VA"
        },
        {
            "name": "Washington",
            "abbreviation": "WA"
        },
        {
            "name": "West Virginia",
            "abbreviation": "WV"
        },
        {
            "name": "Wisconsin",
            "abbreviation": "WI"
        },
        {
            "name": "Wyoming",
            "abbreviation": "WY"
        }
    ]

    constructor(
        
        private _formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private apiService: ApiService,
        private alertPopupService: AlertPopupService,
        private alertService: AlertService,
        private configService: ConfigService,
        private whitelabelService: WhitelabelService
        ) { 


        }

    ngOnInit() {
        this.associatesFormGroup = this._formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            dob: ['', Validators.required],
            email: [''],
          });

          this.initAssociates();

          if(this.configService.configs.skipUpdateMember){
            this.updateMember(1);
          }
    }

     updateMember(tryCount){
        this.loading = true;
        this.apiService.updateFirstTime(this.member).subscribe(async r=>
        {
        
                this.member = r;
                if(!this.member.currentProductId){
                    var w =  AppComponent.whitelabel;
                    this.member.currentProductId = w.productId;
                }
                this.initAssociates();

                //now we call pre-register for temporary
                this.apiService.addAssociates(this.member.memberId,  this.member.currentProductId,tryCount,this.gurardians.concat(this.dependents)).subscribe(r=>
                    {
                        console.log(r);
                            this.memberChange.emit();    
                            this.loading = false;     
 
                    },err=>{
                        console.log("error: " + err);
                        this.loading = false;     
                        this.alertPopupService.showMessage(err.message, "", MessageSeverity.error);
                    })

            
        },err=>{
            console.log("error: " + err);
            this.loading = false;
        })
    }

    initAssociates(){
        
        if((new Date()).getFullYear() - new Date(this.member.dob).getFullYear() >= 18){
            this.over18 = true;
        }else{
            this.over18 = false;
            if(this.gurardians.length == 0){
                this.addGuardian();
            }
            
        }
    }

    addGuardian(){
        this.gurardians.push(new Associate(2, this.member.memberId));
    }

    addDependent(){
        this.dependents.push(new Associate(1, this.member.memberId));
    }

    removeGuardian(index){
        this.gurardians.splice(index,1);
    }

    removeDependent(index){
        this.dependents.splice(index,1);
    }

    // ok(){
    //     if(this.gurardians.length > 0){
    //         var ssoGuardian = this.gurardians[0];
    //         ssoGuardian.isSSOGuardian = true;
    //         if((new Date()).getFullYear() - new Date(ssoGuardian.dob).getFullYear() < 18){
    //             this.alertPopupService.showMessage("Guardian's age need to be over 18", "", MessageSeverity.error);
    //             return;
    //         }
    //     }


    //     this.apiService.addAssociates(this.member.memberId, this.gurardians.concat(this.dependents)).subscribe(r=>
    //     {
    //         if(r.success=="True"){
    //             this.memberChange.emit();         
    //         }
    //     },err=>{
    //         this.alertPopupService.showMessage(err.message, "", MessageSeverity.error);
    //     })
    // }

}



// WEBPACK FOOTER //
// ./src/app/update-first-time/update-first-time.component.ts